import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'next/router';
import styled, { css } from 'styled-components';
import { hover } from 'Styles/helpers';
import UnstyledList from '../unstyled-list';
import Facebook from '../svg/facebook.svg';
import Twitter from '../svg/twitter.svg';
import FacebookCircle from '../svg/facebook-circle.svg';
import TwitterCircle from '../svg/twitter-circle.svg';

const renderSocialIcon = (hasCircle, icon) => {
  switch (icon) {
    case 'facebook':
      if (hasCircle) {
        return <FacebookCircle />;
      }
      return <Facebook />;
    default:
      if (hasCircle) {
        return <TwitterCircle />;
      }
      return <Twitter />;
  }
};

const ShareList = ({ styles, fbShareMessage, twitterShareMessage, hasCircle, isDark }) => {

  const fbMessage = fbShareMessage && encodeURIComponent(fbShareMessage);
  const twitterMessage = twitterShareMessage && encodeURIComponent(twitterShareMessage);

  return (
    <List styles={styles} hasCircle={hasCircle} isDark={isDark}>
      <li>
        <a
          href={`https://facebook.com/sharer/sharer.php?u=${fbMessage}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="Share on Facebook"
        >
          {renderSocialIcon(hasCircle, 'facebook')}
        </a>
      </li>
      <li>
        <a
          href={`https://twitter.com/intent/tweet/?text=${twitterMessage}`}
          target="_blank"
          rel="nofollow noopener noreferrer"
          aria-label="Share on Twitter"
        >
          {renderSocialIcon(hasCircle, 'twitter')}
        </a>
      </li>
    </List>
  );
};

const List = styled(UnstyledList)`
  margin: 50px auto;

  li {
    display: inline-block;

    &:not(:first-of-type) {
      margin-left: ${props => props.hasCircle ? '10px' : '25px'};
    }
  }

  a {
    color: ${props => props.theme.blue};

    ${css`
      ${props => hover(`
        color: ${props.isDark ? '#fff' : props.theme.black};
      `)}
    `}
  }

  svg {
    max-height: ${props => props.hasCircle ? '40px' : '18px'};
  }

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

ShareList.propTypes = {
  styles: PropTypes.string,
  fbShareMessage: PropTypes.string,
  twitterShareMessage: PropTypes.string,
  hasCircle: PropTypes.bool,
  isDark: PropTypes.bool,
};

export default withRouter(ShareList);
